// Exports
export default {
	"Modal": "Modal_Cf+65",
	"Container": "Container_xRQiU",
	"Header": "Header_YdiBB",
	"HeaderButtonContainer": "HeaderButtonContainer_LzoLi",
	"HeaderText": "HeaderText_1uG5L",
	"ContentContainer": "ContentContainer_oASob",
	"scrolable": "scrolable_VpXIh",
	"ImageContainer": "ImageContainer_PzyO6",
	"Image": "Image_ovrin",
	"Footer": "Footer_HrVo5",
	"ContentText": "ContentText_Uwvz6",
	"ContentCheckbox": "ContentCheckbox_KP95g"
};
